import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, BookOpen, Clock3, HelpCircle, MessageCircle } from 'lucide-react';
import { getKakaoChatUrl, isValidKakaoPfUrl, openExternalUrl } from '../lib/openExternal';
import '../styles/support-design.css';

export default function Support() {
  const lastTapRef = useRef(0);
  const openKakaoChat = () => {
    const now = Date.now();
    if (now - lastTapRef.current < 600) return;
    lastTapRef.current = now;
    const url = getKakaoChatUrl();
    if (!isValidKakaoPfUrl(url)) { alert('카카오톡 상담을 연결할 수 없습니다. 잠시 후 다시 시도해 주세요.'); return; }
    openExternalUrl(url);
  };
  return <div className="jp-site jp-help-page jp-help-compact">
    <header className="jp-wrap jp-help-heading"><h1>고객센터</h1></header>
    <section className="jp-wrap jp-support-grid" aria-label="고객지원 방법">
      <article className="jp-support-card jp-support-chat"><span className="jp-support-icon"><MessageCircle size={26} strokeWidth={1.6} /></span><h2>카카오톡 상담</h2><p>접수 순서대로 답변드립니다.</p><button type="button" className="jp-button" onClick={openKakaoChat}>상담하기<ArrowUpRight size={17} /></button></article>
      <article className="jp-support-card"><span className="jp-support-icon"><HelpCircle size={26} strokeWidth={1.6} /></span><h2>자주 묻는 질문</h2><p>궁금한 내용을 빠르게 찾아보세요.</p><Link to="/faq" className="jp-text-link">질문 보기<ArrowUpRight size={17} /></Link></article>
      <article className="jp-support-card"><span className="jp-support-icon"><BookOpen size={26} strokeWidth={1.6} /></span><h2>이용안내</h2><p>등록부터 송금까지 순서대로 확인하세요.</p><Link to="/guide" className="jp-text-link">이용안내 보기<ArrowUpRight size={17} /></Link></article>
    </section>
    <section className="jp-wrap jp-support-contact" aria-labelledby="jp-support-contact-title"><h2 id="jp-support-contact-title">운영 안내</h2><dl><div><dt><Clock3 size={18} />상담 시간</dt><dd>평일 09:00~17:30</dd></div></dl></section>
    <nav className="jp-wrap jp-help-inline" aria-label="약관과 개인정보 안내"><Link to="/terms">이용약관<ArrowUpRight size={15} /></Link><Link to="/privacy">개인정보처리방침<ArrowUpRight size={15} /></Link></nav>
  </div>;
}
